"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEXT_REST_TIME_MAX_LENGTH_SHORT = exports.UPLOAD_PATH = exports.NUMBER_MAX_FOUR_DECIMALS = exports.NUMBER_MAX_THREE_DECIMALS = exports.NUMBER_MAX_TWO_DECIMALS = exports.TEXT_MAX_LENGTH_CONTENT = exports.TEXT_MAX_LENGTH_COMMENTS = exports.TEXT_MAX_LENGTH_DESCRIPTION = exports.TEXT_MAX_LENGTH_URL = exports.TITLE_MAX_LENGTH_NAME = exports.TEXT_MAX_LENGTH_NAME = exports.TEXT_MAX_LENGTH_SHORT = void 0;
exports.TEXT_MAX_LENGTH_SHORT = 11;
exports.TEXT_MAX_LENGTH_NAME = 100;
exports.TITLE_MAX_LENGTH_NAME = 60;
exports.TEXT_MAX_LENGTH_URL = 150;
exports.TEXT_MAX_LENGTH_DESCRIPTION = 500;
exports.TEXT_MAX_LENGTH_COMMENTS = 1000;
exports.TEXT_MAX_LENGTH_CONTENT = 4000;
exports.NUMBER_MAX_TWO_DECIMALS = 99;
exports.NUMBER_MAX_THREE_DECIMALS = 999;
exports.NUMBER_MAX_FOUR_DECIMALS = 9999;
exports.UPLOAD_PATH = '/uploads/public';
exports.TEXT_REST_TIME_MAX_LENGTH_SHORT = 10;
//# sourceMappingURL=constants.js.map